import React, { useEffect } from 'react';
import { Form, Input, Button, Select, FormInstance } from 'antd';
import { PatternFormat } from 'react-number-format';
import { ContractorFormValues } from '../../types/contractor';
import { ContractorAvailableAreaSelector } from './ContractorAvailableAreaSelector';

interface ContractorFormProps {
  form: FormInstance<ContractorFormValues>;
  loading: boolean;
  onFinish: (values: ContractorFormValues) => void;
  submitText: string;
  showUserField?: boolean;
  userOptions?: { label: string; value: string; disabled?: boolean }[];
  initialValues?: Partial<ContractorFormValues>;
}

export const ContractorForm: React.FC<ContractorFormProps> = ({
  form,
  loading,
  onFinish,
  submitText,
  showUserField = false,
  userOptions = [],
  initialValues,
}) => {
  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    }
  }, [form, initialValues]);

  return (
    <Form form={form} layout="vertical" onFinish={onFinish} initialValues={initialValues}>
      {showUserField && (
        <Form.Item
          name="userId"
          label="User"
          rules={[{ required: true, message: 'Please select a user' }]}>
          <Select
            showSearch
            optionFilterProp="label"
            placeholder="Select a contractor user"
            options={userOptions}
          />
        </Form.Item>
      )}
      <Form.Item
        name="name"
        label="Company"
        rules={[{ required: true, message: 'Please enter company name' }]}>
        <Input placeholder="Company name" />
      </Form.Item>
      <Form.Item
        name="phone"
        label="Phone"
        rules={[
          { required: true, message: 'Please enter phone number' },
          {
            pattern: /^\(\d{3}\) \d{3}-\d{4}$/,
            message: 'Please enter a valid phone number',
          },
        ]}>
        <PatternFormat
          customInput={Input}
          format="(###) ###-####"
          mask="_"
          placeholder="(555) 555-5555"
        />
      </Form.Item>
      <Form.Item
        name="email"
        label="Email"
        rules={[
          { required: true, message: 'Please enter email' },
          { type: 'email', message: 'Please enter a valid email' },
        ]}>
        <Input placeholder="company@email.com" />
      </Form.Item>
      <Form.Item name="description" label="Description">
        <Input.TextArea placeholder="Describe your company" rows={4} />
      </Form.Item>
      <Form.Item name="availableArea">
        <ContractorAvailableAreaSelector />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          {submitText}
        </Button>
      </Form.Item>
    </Form>
  );
};
